let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("gx9QH")).then(() => parcelRequire('aBYiX'));